import React from 'react';
import { ButtonV2 } from '@zola/zola-ui';

import mobileImg from '../../../../assets/images/seating-chart/mobile-view.svg';
import './MobileView.styles.less';

const MobileView = () => (
  <div className="sc__mobile">
    <div className="sc__mobile__wrapper">
      <img className="sc__mobile__image" src={mobileImg} alt="mobile view" />
      <h1 className="sc__mobile__title">Head to a Computer to Get Started</h1>
      <p className="sc__mobile__text">At the moment, our seating chart tool only works on larger screens like your laptop.</p>
      <ButtonV2 component="a" href="/wedding/manage/events" className="sc__mobile__button">Go Back</ButtonV2>
    </div>
  </div>
);

export default MobileView;



// WEBPACK FOOTER //
// ./src/components/manage/seatingchart/MobileView/MobileView.jsx